module.exports = __webpack_public_path__ + "img/hero-03.b9e0f440.jpg";